import clsx from "clsx";

import Heading from "../../Heading";
import RichTextLink from "../RichTextLink";
import * as styles from "./styles.module.scss";

export function RichTextList({
  title,
  list,
  list_type,
}: Partial<ListComponent>) {
  const renderList = (listArr: Array<TextElement | LinkElement>) => {
    return listArr.map((item) => {
      if (item.component === "element_link") {
        return (
          <li key={item.url}>
            <RichTextLink {...item} />
          </li>
        );
      }

      return <li key={item.text}>{item.text}</li>;
    });
  };

  return (
    <div
      className={clsx(
        {
          [styles.ordered]: list_type === "ordered",
        },
        styles.customList
      )}
    >
      {title && <Heading level={3}>{title}</Heading>}
      {list &&
        list.length > 0 &&
        (list_type === "unordered" ? (
          <ul className={styles.list}>{renderList(list)}</ul>
        ) : (
          <ol className={styles.list}>{renderList(list)}</ol>
        ))}
    </div>
  );
}
